import { render, staticRenderFns } from "./OutfitModal.vue?vue&type=template&id=274905d2&scoped=true"
import script from "./OutfitModal.vue?vue&type=script&lang=js"
export * from "./OutfitModal.vue?vue&type=script&lang=js"
import style0 from "./OutfitModal.vue?vue&type=style&index=0&id=274905d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274905d2",
  null
  
)

export default component.exports